(function () {'use strict';}());
angular.module("app").service("AnalyticsService", function(){

    // NOT YET IN USE.

    var service = this;

    // function sendEvent(category, action, label){
    //     ga("send", "event", {
    //         eventCategory: category,
    //         eventAction: action,
    //         eventLabel: label
    //     });
    // }
    //
    // service.miniGame = function(title, action){
    //     sendEvent("Mini Game", action, title);
    // };
    //
    // service.adventureSelection = function(label, action){
    //     sendEvent("Adventure Selection", action, label);
    // };
    //
    // service.game = function(label, action){
    //     sendEvent("Game", action, label);
    // };

});
